'use client';

import { Button } from '@common/components';
import { cn } from '@core/utils';
import Link from 'next/link';

import { DonationButton } from '@/app/donation/_components/DonationButton/DonationButton';

interface CtaButtonProps {
  ctaText?: string;
  ctaLinkUrl?: string;
  ctaButtonColor?: string;
  ctaButtonTextColor?: string;
  institutionId: number;
  institutionName: string;
  disabled?: boolean;
}

export const CtaButton = ({
  ctaText,
  ctaLinkUrl,
  ctaButtonColor,
  ctaButtonTextColor,
  institutionId,
  institutionName,
  disabled,
}: CtaButtonProps) => {
  const notHaveCtaLinkUrlArea = institutionId ? (
    <div className={cn('sticky bottom-0 w-full bg-Gray-white px-20 py-16')}>
      <DonationButton
        institutionId={institutionId}
        institutionName={institutionName}
        disabled={disabled}
        style={{
          ...(ctaButtonColor ? { backgroundColor: ctaButtonColor } : {}),
          ...(ctaButtonTextColor ? { color: ctaButtonTextColor } : {}),
        }}
      >
        {ctaText}
      </DonationButton>
    </div>
  ) : null;

  return ctaLinkUrl ? (
    <div className={cn('sticky bottom-0 w-full bg-Gray-white px-20 py-12')}>
      <Button
        asChild
        className="w-full"
        disabled={disabled}
        style={{
          ...(ctaButtonColor ? { backgroundColor: ctaButtonColor } : {}),
          ...(ctaButtonTextColor ? { color: ctaButtonTextColor } : {}),
        }}
      >
        <Link
          href={ctaLinkUrl}
          onClick={(e) => {
            if (disabled) {
              e.preventDefault();

              return;
            }
          }}
        >
          {ctaText}
        </Link>
      </Button>
    </div>
  ) : (
    notHaveCtaLinkUrlArea
  );
};
